
import CookieUtils from './cookie-utils.js';
import QuantityInput from './quantity-input';
import ZipCodeStateLookup from "./zipcode-state-lookup";
import DomAdjuster from './dom-adjuster';
import CountDownTimer from "./countdown-timer";

class PipEventObserver {

	static addToCart(model, setDetails){
		try{
			if(!window.PIP_EVENTS || !window.PIP_EVENTS.cart){
				return;
			}
			window.PIP_EVENTS.cart.addToCart.off('STH BOPIS DeliverFromStore ShipToStore');
			window.PIP_EVENTS.cart.addToCart.on('STH BOPIS DeliverFromStore ShipToStore',function(e){
			    let count = CookieUtils.getCartCount();
				model.fulfillmentDetails.emptyCart = (count === 0 || count === "0" || count === "");
				setDetails({...model});
			});
		}catch(e){
			console.error(e);
		}
	}

	static shippingZipChanged(model, setDetails, selectedOption, setSelectedOption){
		try{
			if(!window.PIP_EVENTS || !window.PIP_EVENTS.shippingOptions){
				return;
			}
	        window.PIP_EVENTS.shippingOptions.shippingOptionsZipCodeWasChanged.off('.shippingZipChanged');
	        window.PIP_EVENTS.shippingOptions.shippingOptionsZipCodeWasChanged.on('.shippingZipChanged', function (evtType, shippingServiceModel) {

	        	if(shippingServiceModel.arrivalDate){
					model.shippingDetails.arrivalDate = shippingServiceModel.arrivalDate
	        	}else{
					model.shippingDetails.estimatedDeliveryDate = shippingServiceModel.arrivalDateIsSingleDate ? shippingServiceModel.arrivalDate : false;
					model.shippingDetails.estimatedShippingStartDate = shippingServiceModel.formattedStartDate;
					model.shippingDetails.estimatedShippingEndDate = shippingServiceModel.formattedEndDate;
	        	}

				if (shippingServiceModel.dynamicETA.hasCountdownTimer) {
					model.shippingDetails.dynamicEta = {};
					model.shippingDetails.dynamicEta.totalMinutes = shippingServiceModel.dynamicETA.totalMinutes;
					CountDownTimer.start(model.shippingDetails.dynamicEta);
				} else {
					delete model.shippingDetails.dynamicEta;
				}

				//TODO: is this available in the ship model?
				delete model.shippingDetails.dynamicEtaOptimalDate;


				model.shippingDetails.sthZipCode = CookieUtils.getCookie("DETA_ZIP");
				model.shippingDetails.sthState = ZipCodeStateLookup.getState(model.shippingDetails.sthZipCode);
				model.shippingDetails = doesSthExclusionApplies(model.fulfillmentDetails, model.shippingDetails);
				if (model.shippingDetails.enabled) {
					setSelectedOption("STH");
					DomAdjuster.toggleSubscription("STH");
					DomAdjuster.toggleAssemblyInstallation("STH");
				} else {
					setSelectedOption("");
					DomAdjuster.toggleSubscription("");
					DomAdjuster.toggleAssemblyInstallation("");
				}
				if (model.fulfillmentDetails.fulfillable) {
					DomAdjuster.toggleHdppOption(true)
				} else {
					DomAdjuster.toggleHdppOption(false)
				}
				applyExpressDeliveryChanges(model, shippingServiceModel);
				setDetails({...model});
	        });
		  }catch(e){
		    console.error(e);
		  }
	}

	static quantityError(model, setDetails, selectedOption, setSelectedOption){
		try{
			if(window.PIP_EVENTS && window.PIP_EVENTS.customer) {
				if(window.PIP_EVENTS.customer.customerQuantityErrorStateChanged) {
					window.PIP_EVENTS.customer.customerQuantityErrorStateChanged.off('.quantityError');
					window.PIP_EVENTS.customer.customerQuantityErrorStateChanged.on('.quantityError', (evtType, state) => {
						// toggleStoreQuantityError: function buybeltToggleStoreQuantityError(evtType, state) {
						try {
							// console.log("PIP_EVENTS.customer.customerQuantityErrorStateChanged", evtType, state, selectedOption);
							model.fulfillmentDetails.quantityError = state.isErrorState;
							QuantityInput.updateTileForBossBopisSharedSku(selectedOption, model, setDetails);
							QuantityInput.updateQuantityError(
								selectedOption,
								model.fulfillmentDetails,
								model.pickupDetails
							);
							//   if (pip.viewModel.bossSharedSkuEnhancementFeature) {
							//     view.toggleFallbackMessages();
							//     view.showMoreBopisProductsTooltip();
							//   } else {
							//     var atcButton = $(view.selectors.addToCartButton);

							//     if (state.isErrorState) {
							//       atcButton.addClass(view.selectors.addToCartButtonErrorStateClassName);
							//     } else {
							//       atcButton.removeClass(view.selectors.addToCartButtonErrorStateClassName);
							//     }
							//   }
							setDetails({...model});
							// onFulfillmentAvailabilityChange("PICKUP", selectedOption, model, setSelectedOption);
						} catch (e) {
							console.error(e);
						}
					});
				}
				if(window.PIP_EVENTS.customer.customerOnlineQuantityErrorStateChanged) {
					window.PIP_EVENTS.customer.customerOnlineQuantityErrorStateChanged.off('.quantityError');
					window.PIP_EVENTS.customer.customerOnlineQuantityErrorStateChanged.on('.quantityError', (evtType, state) => {
						try {
							// console.log("PIP_EVENTS.customer.customerOnlineQuantityErrorStateChanged", evtType, state, selectedOption);
							model.fulfillmentDetails.onlineQuantityError = state.isErrorState;
							QuantityInput.updateQuantityError(
								selectedOption,
								model.fulfillmentDetails,
								model.pickupDetails
							);
							setDetails({...model});
						} catch (e) {
							console.error(e);
						}
					});
				}
			} else {
				return null;
			}
		}catch(e){
			console.error(e);
		}
	}

	static installationSelected(model, setDetails, selectedOption, setSelectedOption){
		try{
			// if(!window.PIP_EVENTS || !window.PIP_EVENTS.attachLabor){
			// 	return;
			// }
	  //       window.PIP_EVENTS.attachLabor.attachLaborOptInStateChanged.off('.buybeltAttachLaborStateChanged');
	  //       window.PIP_EVENTS.attachLabor.attachLaborOptInStateChanged.on('.buybeltAttachLaborStateChanged', function (evtType, state) {
	  //         // view.updateDOM.buybeltStoreBox();
   //          	try{
	  //       		console.log("PIP_EVENTS.attachLabor.attachLaborOptInStateChanged", evtType, state);
	  //       		model.pickupDetails.installSelected = model.pickupDetails.installSelected?false:true;
	  //       		setDetails({...model})
	  //       		onFulfillmentAvailabilityChange("PICKUP", selectedOption, model, setSelectedOption);

	  //       	}catch(e){
	  //       		console.error(e);
	  //       	}
	  //       });
		}catch(e){
			console.error(e);
		}
	}

	static proInstallationSelected(model, setDetails, selectedOption){
		try{
			if(!window.PIP_EVENTS || !window.PIP_EVENTS.dualPath){
				return;
			}
	        window.PIP_EVENTS.dualPath.dualPathOptInStateChanged.off('.buybeltDualPath');
	        window.PIP_EVENTS.dualPath.dualPathOptInStateChanged.on('.buybeltDualPath', function (evtType, state) {
            	try{
	        		// console.log("PIP_EVENTS.dualPath.dualPathOptInStateChanged", evtType, state);
	        		model.fulfillmentDetails.proInstallSelected = model.fulfillmentDetails.proInstallSelected?false:true;
	        		// model.fulfillmentDetails.doHideForNotifyMe = model.fulfillmentDetails.doHideForNotifyMe?false:true;
	        		setDetails({...model})

	        		//handle disabled not getting applied to instant checkout for some reason
	        		try{
	        			setTimeout(()=>{
							const icButton = document.querySelector('#atc_instant_checkout');
		        			if(icButton && selectedOption!=="STH"){
		        				icButton.setAttribute("disabled", true);
		        			}
	        			}, 0)
	        		}catch(e){
	        			console.error(e);
	        		}
	        	}catch(e){
	        		console.error(e);
	        	}
	        });
		}catch(e){
			console.error(e);
		}
	}

}

function applyExpressDeliveryChanges(model, shippingServiceModel){
	try{
		const {expressDetails, shippingDetails} = model;
		if(shippingServiceModel && shippingServiceModel.shipModes){
			let bodfs = shippingServiceModel.shipModes.filter((mode)=>(mode.isBodfsShipMode));
			if(expressDetails.enabled && bodfs.length===0){
				expressDetails.enabled = false;
				expressDetails.estimatedDeliveryCharge = "";
			}else if(bodfs.length>0){
				bodfs = bodfs[0];
				expressDetails.zipCode = shippingDetails.sthZipCode;
				expressDetails.storeDeliveryTimeline = bodfs.deliveryDateAvailability;
				expressDetails.estimatedDeliveryCharge = bodfs.shipCharge;
				expressDetails.isDeliveryTimelineTodayOrTomorrow = bodfs.isDeliveryTimelineTodayOrTomorrow;
				expressDetails.enabled = true;
				// Missing these in response:
				// expressDetails.carDeliveryCharge = "8.99";
				// expressDetails.vanDeliveryCharge = "35.00";
				// expressDetails.truckDeliveryCharge = "79.00";
				// expressDetails.isDeliveryPriceDisplayable = true;
				// expressDetails.isAssemblyEligible = false;
				// expressDetails.isAlphaPromptRestricted = false;
				// expressDetails.isFreeDelivery = false;
			}
		}
	}catch(e){
		console.error(e);
	}
}

function onFulfillmentAvailabilityChange(disabledOption, selectedOption, model, setSelectedOption) {
	try{
		if(disabledOption===selectedOption){
			setSelectedOption("STH");
		}
	}catch(e){
		console.error(e);
	}
}

function doesSthExclusionApplies(fulfillmentDetails, shippingDetails) {
	if( fulfillmentDetails && fulfillmentDetails.shippingExclusion &&
		fulfillmentDetails.shippingExclusion.exclusionLocations &&
		shippingDetails.sthState &&
		fulfillmentDetails.shippingExclusion.exclusionLocations.includes(shippingDetails.sthState) &&
		(shippingDetails.sthState === "AK" || shippingDetails.sthState === "HI"))
	{
			shippingDetails.enabled = false;
			shippingDetails.sthShippingExclusionApplies = true;
	} else {
		shippingDetails.enabled = true;
		shippingDetails.sthShippingExclusionApplies = false;
	}
    return shippingDetails;
}

export default PipEventObserver;
